import React, { ChangeEvent } from "react";

interface InputMaskProps {
  type: string;
  id: string;
  placeholder: string;
  required?: boolean;
  className?: string;
  "aria-label"?: string;
}

const InputMask: React.FC<InputMaskProps> = ({ type, ...props }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    switch (type) {
      case "tel":
        // Remove tudo que não é número
        value = value.replace(/\D/g, "");
        // Aplica a máscara (XX) XXXXX-XXXX
        value = value.replace(/^(\d{2})(\d)/g, "($1) $2");
        value = value.replace(/(\d)(\d{4})$/, "$1-$2");
        e.target.value = value.slice(0, 15);
        break;

      case "cpf":
        // Remove tudo que não é número
        value = value.replace(/\D/g, "");
        // Aplica a máscara XXX.XXX.XXX-XX
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        e.target.value = value.slice(0, 14);
        break;

      case "cnpj":
        value = value.replace(/\D/g, "").slice(0, 14);
        if (value.length > 12) {
          value = value.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/,
            "$1.$2.$3/$4-$5",
          );
        } else if (value.length > 8) {
          value = value.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{0,4})/,
            "$1.$2.$3/$4",
          );
        } else if (value.length > 5) {
          value = value.replace(/^(\d{2})(\d{3})(\d{0,3})/, "$1.$2.$3");
        } else if (value.length > 2) {
          value = value.replace(/^(\d{2})(\d{0,3})/, "$1.$2");
        }
        e.target.value = value;
        break;

      case "placa":
        // Remove caracteres especiais
        value = value.replace(/[^a-zA-Z0-9]/g, "");
        // Converte para maiúsculo
        value = value.toUpperCase();
        // Aplica a máscara XXX-XXXX
        if (value.length > 3) {
          value = value.slice(0, 3) + "-" + value.slice(3);
        }
        e.target.value = value.slice(0, 8);
        break;

      case "money":
        // Remove tudo que não é número
        value = value.replace(/\D/g, "");
        // Converte para número e formata como moeda
        value = (Number(value) / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        e.target.value = value;
        break;
    }
  };

  return (
    <input
      {...props}
      type={
        type === "cpf" ||
        type === "cnpj" ||
        type === "placa" ||
        type === "money"
          ? "text"
          : type
      }
      onChange={handleChange}
    />
  );
};

export default InputMask;
